import script from "./related-links-widget-link.vue?vue&type=script&setup=true&lang=js"
export * from "./related-links-widget-link.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__